import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, FileText, Users, Sparkles } from "lucide-react";

const Hero = () => {
  return <section className="relative flex items-center justify-center overflow-hidden" style={{ minHeight: "90vh", backgroundColor: "#F8F8F6" }}>
      <div className="container relative z-10 px-6 py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          {/* Eyebrow */}
          <p className="text-xs font-medium tracking-[0.2em] uppercase text-muted-foreground mb-6 opacity-0 animate-fade-up" style={{
          animationDelay: "0.1s"
        }}>
            No more chasing people down
          </p>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-foreground mb-6 text-balance opacity-0 animate-fade-up" style={{
          animationDelay: "0.2s"
        }}>
            Your team's updates.
            <br />
            Collected, summarized, done.
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-xl mx-auto mb-10 text-balance opacity-0 animate-fade-up" style={{
          animationDelay: "0.3s"
        }}>
            Send each person a link. They fill it out. You get a report worth reading. That's it.
          </p>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 opacity-0 animate-fade-up" style={{
          animationDelay: "0.4s"
        }}>
            <Link to="/signup">
              <Button variant="hero" size="xl">
                Get Started
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>

        {/* Feature highlights */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto opacity-0 animate-fade-up" style={{
        animationDelay: "0.5s"
      }}>
          <FeatureCard icon={<Users className="w-5 h-5" />} title="No login headaches" description="Each person gets their own link. Click, fill out, submit. Done." />
          <FeatureCard icon={<Sparkles className="w-5 h-5" />} title="The summary writes itself" description="Raw responses go in. A clean, executive-ready report comes out." />
          <FeatureCard icon={<FileText className="w-5 h-5" />} title="Ready to share in one click" description="PDF, formatted, professional. Drop it in an email or print it." />
        </div>
      </div>
    </section>;
};

const FeatureCard = ({
  icon,
  title,
  description
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => {
  return <div className="group p-5 rounded-lg bg-card border border-border/60 transition-colors duration-200 hover:border-border">
      <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-3 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-200">
        {icon}
      </div>
      <h2 className="font-medium text-foreground mb-1.5">{title}</h2>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>;
};

export default Hero;
